module.exports = __webpack_public_path__ + "static/media/medium-brands.73ec13a7.svg";